/**
 * Painel do lote no setor: os ambientes do lote que estão aqui, quantas peças
 * deles estão desmembradas circulando e o atalho para mover todos de uma vez
 * (o mesmo que arrastar o cartão do lote).
 */
import React, { useEffect, useState } from "react";

import AsyncButton from "../../../components/AsyncButton";
import SlideOverPanel from "../../../components/SlideOverPanel";
import { plural } from "../../../utils/dinheiro";
import { ROTULO_STATUS_AMBIENTE, TOM_STATUS_AMBIENTE } from "../dados/vocabulario";
import { CamposLugar } from "./formularios";
import { textoDasPecasFora, textoDoPrazo } from "./modelo";
import { Acoes, ItemLista, Lista, Secao, Vazio } from "./styles";
import { ErroDaAcao, PillStatus, useErroDeAcao } from "./ui";

/**
 * Props: aberto, lote, setorId, setorNome, estado, podeOperar, hoje, acoes,
 * onFechar, onAbrirAmbiente(demanda), onRecarregar.
 */
export default function DetalheLote({
  aberto,
  lote,
  setorId,
  setorNome = "",
  estado,
  podeOperar,
  hoje,
  acoes,
  onFechar,
  onAbrirAmbiente,
  onRecarregar,
}) {
  const { erro, rodar, limpar } = useErroDeAcao();
  const [lugar, setLugar] = useState({ subsetorId: null, postoId: null });
  useEffect(() => {
    if (aberto) {
      setLugar({ subsetorId: null, postoId: null });
      limpar();
    }
  }, [aberto, lote?.chave, limpar]);

  const comChave = (lote?.demandas || []).filter((d) => d.chave);
  const pecasFora = textoDasPecasFora(lote?.pecasFora);
  return (
    <SlideOverPanel
      open={aberto}
      onClose={onFechar}
      title={lote ? lote.rotulo : "Lote"}
      subtitle={
        lote
          ? [plural(lote.demandas.length, "ambiente", "ambientes"), setorNome].filter(Boolean).join(" em ")
          : ""
      }
      width="min(96vw, 560px)"
    >
      {!lote ? (
        <Vazio>Este lote não tem mais ambientes neste setor.</Vazio>
      ) : (
        <>
          <ErroDaAcao erro={erro} onRecarregar={onRecarregar} />
          <Secao aria-label="Ambientes do lote">
            <h3>Ambientes</h3>
            {pecasFora && <p className="nota">{pecasFora} deste lote circulando fora dos ambientes.</p>}
            <Lista>
              {lote.demandas.map((d) => (
                <ItemLista key={d.chaveLinha} data-clicavel="sim" onClick={() => onAbrirAmbiente(d)}>
                  <span className="principal">
                    <span className="l1">{d.rotulo || d.ambiente}</span>
                    <span className="l2">
                      {d.cliente || "Sem cliente"} · {textoDoPrazo(d.prazoEfetivo, hoje).texto}
                      {d.pecasFora ? ` · ${textoDasPecasFora(d.pecasFora)}` : ""}
                    </span>
                  </span>
                  <PillStatus tom={d.atrasada ? "danger" : TOM_STATUS_AMBIENTE[d.statusApp]}>
                    {ROTULO_STATUS_AMBIENTE[d.statusApp]}
                  </PillStatus>
                </ItemLista>
              ))}
            </Lista>
          </Secao>
          {podeOperar && comChave.length > 0 && (
            <Secao aria-label="Mover o lote">
              <h3>Mover o lote inteiro</h3>
              <CamposLugar setorId={setorId} estado={estado} {...lugar} onChange={setLugar} />
              <Acoes>
                <AsyncButton
                  silentError
                  successMessage={`${plural(comChave.length, "ambiente distribuído", "ambientes distribuídos")}.`}
                  onClick={() => rodar(() => acoes.alocarVarios(comChave, lugar))}
                >
                  Mover {plural(comChave.length, "ambiente", "ambientes")}
                </AsyncButton>
              </Acoes>
            </Secao>
          )}
        </>
      )}
    </SlideOverPanel>
  );
}
